"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const material_1 = require("@mui/material");
const rootUiActions_1 = require("companion-app-components/flux/root-ui/rootUiActions");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const dataset_shares_1 = require("companion-app-components/flux/dataset-shares");
const datasetSharesTypes_1 = require("companion-app-components/flux/dataset-shares/datasetSharesTypes");
const auth_1 = require("companion-app-components/flux/auth");
const datasets_1 = require("companion-app-components/flux/datasets");
const entitlementsUtils_1 = require("companion-app-components/flux/entitlements/entitlementsUtils");
const core_1 = require("companion-app-components/utils/core");
const AccountGroupsShare_1 = __importDefault(require("components/AccountGroupsShare"));
const AccessTypes_1 = __importDefault(require("./AccessTypes"));
const actions_1 = require("./actions");
const utils_1 = require("./components/utils");
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ManageAccountShare = ({ share }) => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const accountGroups = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getAccountGroups);
    const datasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const datasetsById = (0, react_redux_1.useSelector)(datasets_1.datasetsSelectors.getDatasetsById);
    const datasetEntitlements = (_a = datasetsById === null || datasetsById === void 0 ? void 0 : datasetsById.get(datasetId)) === null || _a === void 0 ? void 0 : _a.entitlements;
    const isCFOUser = (0, entitlementsUtils_1.hasCFOEntitlementForDataset)(datasetEntitlements);
    const [accountGroupsState, setAccountGroupsState] = (0, react_1.useState)([]);
    const [fullAccess, setFullAccess] = (0, react_1.useState)((0, utils_1.hasDatasetFullAccess)(accountGroups, share));
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!accountGroups) {
            return;
        }
        const { read, write } = (_b = (_a = share.itemAccessControl) === null || _a === void 0 ? void 0 : _a.resources.ACCOUNT_GROUP) !== null && _b !== void 0 ? _b : {};
        const accountGroupsWithAccess = accountGroups === null || accountGroups === void 0 ? void 0 : accountGroups.map((accountGroup) => {
            const acGroup = accountGroup.toJS();
            if (write === null || write === void 0 ? void 0 : write.includes(accountGroup.id))
                return Object.assign(Object.assign({}, acGroup), { permission: 'WRITE' });
            if (read === null || read === void 0 ? void 0 : read.includes(accountGroup.id))
                return Object.assign(Object.assign({}, acGroup), { permission: 'READ' });
            return Object.assign(Object.assign({}, acGroup), { permission: 'NONE' });
        });
        const nextFullAccess = (0, utils_1.hasDatasetFullAccess)(accountGroups, share);
        setAccountGroupsState(accountGroupsWithAccess);
        setFullAccess(nextFullAccess);
    }, [accountGroups, share]);
    const areAllNone = !fullAccess && accountGroupsState.every((group) => group.permission === 'NONE');
    const handleClose = () => {
        dispatch((0, rootUiActions_1.removeDialog)(actions_1.DIALOG_TYPE_ACCOUNT_SHARE));
    };
    const handleAccessChange = (id, selectedAccess) => {
        const updated = accountGroupsState.map((accountGroup) => accountGroup.id === id ? Object.assign(Object.assign({}, accountGroup), { permission: selectedAccess }) : accountGroup);
        setAccountGroupsState(updated);
    };
    const handleUpdate = () => {
        if (accountGroupsState) {
            const write = accountGroupsState
                .filter((accountGroup) => accountGroup.permission === 'WRITE')
                .map((accountGroup) => accountGroup.id);
            const read = accountGroupsState
                .filter((accountGroup) => accountGroup.permission === 'READ')
                .map((accountGroup) => accountGroup.id);
            const itemAccessControl = {
                version: '1.0.0',
                resources: {
                    ACCOUNT_GROUP: {
                        write: fullAccess ? ['*'] : write,
                        read: fullAccess ? ['*'] : read,
                        delete: [],
                    },
                    Q17_ACCOUNT: {
                        write: fullAccess ? ['*'] : write,
                        read: fullAccess ? ['*'] : read,
                        delete: [],
                    },
                },
            };
            const shareUpdated = (0, datasetSharesTypes_1.mkDatasetShare)({ id: share.id, itemAccessControl });
            core_1.tracker.track(core_1.tracker.events.datasetSharing, Object.assign({ property: 'changePermission' }, (isCFOUser && (0, utils_1.getCFOEntityAccessTrackingProps)(fullAccess, accountGroupsState.length, read, write))));
            dispatch(dataset_shares_1.datasetSharesActions.updateDatasetShare(shareUpdated));
        }
        handleClose();
    };
    return (<Dialog_1.default open sx={{
            '& .MuiPaper-root': {
                padding: '0 20px',
            },
        }}>
      <DialogTitle_1.default className={classes.dialogTitleWrapper}>
        <Typography_1.default variant="h6" className={classes.title}>
          Change Permission
        </Typography_1.default>
      </DialogTitle_1.default>
      <IconButton_1.default aria-label="close" onClick={handleClose} className={classes.closeButton}>
        <Close_1.default />
      </IconButton_1.default>
      <DialogContent_1.default dividers sx={{ p: 0, pb: 2.5 }}>
        <AccessTypes_1.default accountGroups={accountGroupsState} fullAccess={fullAccess} handleFullAccessChange={(event) => setFullAccess(event.target.value === 'true')}/>
        {!fullAccess &&
            <AccountGroupsShare_1.default accountGroups={accountGroupsState} onAccessLevelChange={handleAccessChange}/>}
      </DialogContent_1.default>
      <material_1.DialogActions className={classes.dialogAction}>
        <material_1.Button onClick={handleClose} variant="outlined" size="small">
          Cancel
        </material_1.Button>
        <material_1.Button variant="contained" size="small" onClick={handleUpdate} disabled={areAllNone}>
          UPDATE
        </material_1.Button>
      </material_1.DialogActions>
    </Dialog_1.default>);
};
exports.default = ManageAccountShare;
